export class MedicineContentModel {
    public medicineId: number;
    public langId: number;
    public brandName: string;
    public additionalTitle: string;
    public inactiveIngredientsContent: string;
}